import PergasLogo from "../../../images/logos/pergas/pergas-logo.png";
import pergasWhiteLogo from "../../../images/logos/pergas/pergas-logo-removebgWhite.png";
import SearchIcon from "@mui/icons-material/Search";
import { useContext, useEffect, useState } from "react";
import ThemeNavigation from "../ThemeNavigation/ThemeNavigation";
import classes from "./ThemeSidebar.module.css";
import ThemeUserInfo from "../ThemeUserInfo/ThemeUserInfo";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import ThemeConstElements from "../ThemeConstElements/ThemeConstElements";
import allSystems from "../../../navbarItems/allSystems";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import { renderToString } from "react-dom/server";
import AuthContext from "../../../store/adminStore/admin-auth-context";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const mountedAllSystemStyle = { animation: "allSystemInAnimation 300ms ease-out" };
const unmountedAllSystemStyle = {
  animation: "allSystemOutAnimation 350ms ease-in",
  animationFillMode: "forwards",
};
const mountedSelectedSystemStyle = { animation: "selectedSystemInAnimation 300ms ease-out" };
const unmountedSelectedSystemStyle = {
  animation: "selectedSystemIOutAnimation 350ms ease-in",
  animationFillMode: "forwards",
};

const ThemeSidebar = ({
  theme,
  userLanguage,
  setThemeOpenSidebar,
  changeTheme,
  openThemeSidebar,
  sidebarTouchStartHandler,
  sidebarTouchEndHandler,
  sidebarTouchMoveHandler,
}) => {
  const [systemPagesearchTxt, setSystemPageSearchTxt] = useState("");
  const [allSystemsSearchTxt, setAllSystemsSearchTxt] = useState("");
  const [systemSidebarItems, setSystemSidebarItems] = useState([]);
  const [copiedSystemSidebarItems, setCopiedSystemSidebarItems] = useState([]);
  const [allSystemSidebarItems, setAllSystemSidebarItems] = useState([...allSystems]);
  const [copiedAllSystemSidebarItems, setCopiedAllSystemSidebarItems] = useState([...allSystems]);
  const [showAllSystems, setShowAllSystem] = useState(false);
  const [allSystemsisMounted, setAllSystemsIsMounted] = useState(false);
  const [systemLabel, setSystemLabel] = useState("");
  const [systemActiveNames, setSystemActiveNames] = useState("");

  const { clientAuthInfo } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const findNav = (navigations) =>
      navigations.find((nav) => {
        if (nav?.items?.length > 0) {
          return findNav(nav.items);
        } else {
          return location.pathname.includes(nav.to);
        }
      });

    const currentRouteNav = allSystems.find((system) => {
      let foundedNav = findNav(system.sidebarNavigations);
      return foundedNav;
    });

    if (currentRouteNav) {
      changeSystemHandler(
        currentRouteNav.sidebarNavigations,
        currentRouteNav.label,
        currentRouteNav.packageNames,
      );
    }
  }, []);

  const moveToHomeHandler = (e) => {
    navigate("/admin-home-page");
  };
  const sidebarTogglerHandler = (e) => {
    e.preventDefault();
    setThemeOpenSidebar((prevState) => !prevState);
  };
  const changeSystemHandler = (sidebarNavs, title, activeEntityName) => {
    setAllSystemsIsMounted(!allSystemsisMounted);
    if (showAllSystems) setShowAllSystem(false);
    // if (!clientAuthInfo?.accessibilities) {
    // toast.alert("package access undefined , refresh or login again!");
    // return;
    // }
    const filterSidbarNavs = sidebarNavs.filter(
      (nav) =>
        clientAuthInfo.accessibilities
          .map((each) => each.selectAccessList)
          .flat(1)
          .includes(nav.name) || nav.items.length,
    );

    setSystemSidebarItems(filterSidbarNavs);
    setCopiedSystemSidebarItems(filterSidbarNavs);
    setSystemActiveNames(activeEntityName);
    setSystemLabel(title);
  };
  const systemPagesSearchChangeHandler = (clientSearch) => {
    setSystemPageSearchTxt(clientSearch);

    if (clientSearch.trim() !== "") {
      let filteredSystemSidebarItems = copiedSystemSidebarItems.filter((item) => {
        return renderToString(item?.label)
          ?.toLowerCase()
          ?.replace(/\s/g, "")
          ?.includes(clientSearch?.toLowerCase()?.replace(/\s/g, ""));
      });
      //  console.log(filteredSystemSidebarItems);
      setSystemSidebarItems(filteredSystemSidebarItems);
    } else {
      setSystemSidebarItems(copiedSystemSidebarItems);
    }
  };
  const allSystemsSearchChangeHandler = (clientSearch) => {
    setAllSystemsSearchTxt(clientSearch);
    if (clientSearch.trim() !== "") {
      let filteredAllSystems = copiedAllSystemSidebarItems.filter((item) => {
        return renderToString(item?.label)
          ?.toLowerCase()
          ?.replace(/\s/g, "")
          ?.includes(clientSearch?.toLowerCase()?.replace(/\s/g, ""));
      });
      //  console.log(filteredAllSystems);
      setAllSystemSidebarItems(filteredAllSystems);
    } else {
      setAllSystemSidebarItems(copiedAllSystemSidebarItems);
    }
  };

  return (
    <>
      <div className={classes.drawerAndTogglerContainer}>
        <div
          onTouchStart={sidebarTouchStartHandler}
          onTouchEnd={sidebarTouchEndHandler}
          onTouchMove={sidebarTouchMoveHandler}
          className={[
            classes.drawer,
            userLanguage === "pe" ? classes.drawerIncorrectLtr : classes.drawerIncorrectRtl,
            theme === "White"
              ? classes.whiteTheme
              : theme === "Pink"
                ? classes.pinkTheme
                : theme === "Gradient"
                  ? classes.gradientTheme
                  : theme === "Dark"
                    ? classes.darkTheme
                    : theme === "Blue"
                      ? classes.BlueTheme
                      : null,
          ].join(" ")}
        >
          {showAllSystems ? (
            <div
              className={[
                classes.selectedSystem,
                // showAllSystems ? classes.hideSelectedSystem : classes.showSelectedSystem,
              ].join(" ")}
              style={allSystemsisMounted ? mountedSelectedSystemStyle : unmountedSelectedSystemStyle}
              onAnimationEnd={() => {
                if (!allSystemsisMounted) setShowAllSystem(false);
              }}
            >
              <div
                className={[
                  classes.corrector,
                  userLanguage === "pe" ? classes.rtlDirectionCorrector : classes.ltrDirectionCorrector,
                ].join(" ")}
              >
                <div className={classes.correctorParts}>
                  <div className={classes.logoContainer}>
                    <img
                      src={theme === "Dark" ? pergasWhiteLogo : PergasLogo}
                      alt="Pergas Logo"
                      className={classes.logo}
                      onClick={moveToHomeHandler}
                    />
                  </div>
                  <div
                    className={[
                      classes.systemTitleContainer,
                      theme === "Dark"
                        ? classes.darkThemeSystemTitleContainer
                        : classes.BarkThemeSystemTitleContainer,
                    ].join(" ")}
                    onClick={(e) => {
                      e.preventDefault();
                      setAllSystemsIsMounted(!allSystemsisMounted);
                      if (!showAllSystems) setShowAllSystem(true);
                    }}
                  >
                    <ArrowCircleRightOutlinedIcon
                      className={
                        userLanguage === "pe"
                          ? classes.rtlSystemTitleToggler
                          : classes.ltrSystemTitleToggler
                      }
                    />
                    <span className={classes.systemTitle}>{systemLabel}</span>
                  </div>
                  <div className={classes.searchInputContainer}>
                    {systemPagesearchTxt?.trim() === "" ? (
                      <label htmlFor="systemNavbarSearch" className={classes.searchLabel}>
                        <SearchIcon />
                        جستجو
                      </label>
                    ) : null}
                    <input
                      id="systemNavbarSearch"
                      className={classes.searchInput}
                      type="text"
                      onChange={(e) => systemPagesSearchChangeHandler(e.target.value)}
                      value={systemPagesearchTxt}
                    />
                  </div>
                  <div className={classes.navigationContainer}>
                    <ThemeNavigation
                      theme={theme}
                      systemSidebarItems={systemSidebarItems}
                      isLoggedIn={clientAuthInfo.isLoggedIn}
                      setThemeOpenSidebar={setThemeOpenSidebar}
                      systemActiveNames={systemActiveNames}
                    />
                  </div>
                </div>
                <div className={classes.correctorParts}>
                  <div className={classes.line}></div>
                  <div className={classes.constPartContainer}>
                    <ThemeConstElements theme={theme} changeTheme={changeTheme} />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {!showAllSystems ? (
            <div
              className={[
                classes.allSystemsContainer,
                // showAllSystems ? classes.showAllSystems : classes.hideAllSystems,
              ].join(" ")}
              style={allSystemsisMounted ? unmountedAllSystemStyle : mountedAllSystemStyle}
              onAnimationEnd={() => {
                if (allSystemsisMounted) setShowAllSystem(true);
              }}
            >
              <div
                className={[
                  classes.corrector,
                  userLanguage === "pe" ? classes.rtlDirectionCorrector : classes.ltrDirectionCorrector,
                ].join(" ")}
              >
                <div className={classes.correctorParts}>
                  <div className={classes.logoContainer}>
                    <img
                      src={theme === "Dark" ? pergasWhiteLogo : PergasLogo}
                      alt="Pergas Logo"
                      className={classes.logo}
                      onClick={moveToHomeHandler}
                    />
                  </div>
                  <div className={classes.allSystemSearchContainer}>
                    {allSystemsSearchTxt?.trim() === "" ? (
                      <label htmlFor="allSystemsNavbarSearch" className={classes.searchLabel}>
                        <SearchIcon />
                        جستجو
                      </label>
                    ) : null}
                    <input
                      id="allSystemsNavbarSearch"
                      className={classes.searchInput}
                      type="text"
                      onChange={(e) => allSystemsSearchChangeHandler(e.target.value)}
                      value={allSystemsSearchTxt}
                    />
                  </div>
                  {/* {isLoggedIn ? ( */}
                  {clientAuthInfo?.accessibilities
                    ? allSystemSidebarItems
                        .filter((item) =>
                          clientAuthInfo.accessibilities
                            .map((each) => each.packageName)
                            .some((r) => item.packageNames.includes(r)),
                        )
                        .map((system) => (
                          <div
                            key={system.id}
                            className={classes.systemContainer}
                            onClick={(e) =>
                              changeSystemHandler(
                                system.sidebarNavigations,
                                system.label,
                                system.packageNames,
                              )
                            }
                          >
                            <span>{system.label}</span>
                            <ArrowBackIosNewIcon
                              className={
                                userLanguage === "pe" ? classes.rtlSystemArrow : classes.ltrSystemArrow
                              }
                            />
                          </div>
                        ))
                    : null}
                  {/* ) : (
                    <div className={classes.dashBoardContainer}>
                      <HomeOutlinedIcon />
                      <MultiLanTxt tid="DASHBOARD" />
                    </div>
                  )} */}
                </div>
                {/* <div className={classes.correctorParts}>
                  <div className={classes.systemContainer}>
                    <Link to="teste-dargah-pardakht-saman">teste dargah pardakht saman</Link>
                  </div>
                </div> */}
                <div className={classes.correctorParts}>
                  <div className={classes.line}></div>
                  <div className={classes.constPartContainer}>
                    <ThemeConstElements theme={theme} changeTheme={changeTheme} />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <div
          onClick={sidebarTogglerHandler}
          className={[
            classes.togglerIconContainer,
            userLanguage === "pe" ? classes.togglerIconRtlLan : classes.togglerIconLtrLan,
            theme === "White"
              ? classes.whiteTheme
              : theme === "Pink"
                ? classes.pinkTheme
                : theme === "Gradient"
                  ? classes.gradientTheme
                  : theme === "Dark"
                    ? classes.darkTheme
                    : theme === "Blue"
                      ? classes.BlueTheme
                      : null,
          ].join(" ")}
        >
          <KeyboardArrowLeftOutlinedIcon
            className={[
              classes.toggler,
              userLanguage === "pe"
                ? openThemeSidebar
                  ? classes.rtlOpenedToggler
                  : classes.rtlClosedToggler
                : openThemeSidebar
                  ? classes.ltrClosedToggler
                  : classes.ltrOpenedToggler,
            ].join(" ")}
          />
        </div>
      </div>
      <div
        className={[
          classes.userInfoContainer,
          userLanguage === "pe" ? classes.userInfoContainerRtlLan : classes.userInfoContainerLtrLan,
          theme === "White"
            ? classes.whiteBGC
            : theme === "Pink"
              ? classes.pinkBGC
              : theme === "Gradient"
                ? classes.gradientBGC
                : theme === "Dark"
                  ? classes.darkBGC
                  : theme === "Blue"
                    ? classes.BlueBGC
                    : null,
        ].join(" ")}
      >
        <ThemeUserInfo />
      </div>
    </>
  );
};

export default ThemeSidebar;
